'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _GEHelper = require("../graphicEngine/GEHelper");
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _clamp2 = _interopRequireDefault(require("lodash/clamp"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
var _fontfaceonload = _interopRequireDefault(require("fontfaceonload"));
var _DataTable = _interopRequireDefault(require("../class/DataTable"));
var _entryModuleLoader = _interopRequireDefault(require("../class/entryModuleLoader"));
var _mathjs = require("mathjs");
var _scheduler = require("./scheduler");
var _uaParserJs = require("ua-parser-js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Entry.Utils = {};
Entry.TEXT_ALIGN_CENTER = 0;
Entry.TEXT_ALIGN_LEFT = 1;
Entry.TEXT_ALIGN_RIGHT = 2;
Entry.TEXT_ALIGNS = ['center', 'left', 'right'];
Entry.clipboard = null;
Entry.CANVAS_MIN_WIDTH = 162;
Entry.CANVAS_DEFAULT_WIDTH = 324;
Entry.CANVAS_MAX_WIDTH = 640;

/**
 * Load project
 * @param {*} project
 */
Entry.loadProject = function (project) {
  var _Entry$variableContai, _Entry$aiLearning, _project;
  Entry.isLoadProject = false;
  if (!project) {
    project = Entry.getStartProject(Entry.mediaFilePath);
  }
  if (this.type === 'workspace') {
    Entry.stateManager.startIgnore();
  }
  Entry.projectId = project._id;
  (_Entry$variableContai = Entry.variableContainer) === null || _Entry$variableContai === void 0 || _Entry$variableContai.setVariables(Entry.Utils.combineCloudVariable(project), {
    aiUtilizeBlocks: project.aiUtilizeBlocks
  });
  Entry.variableContainer.setMessages(project.messages);
  Entry.variableContainer.setFunctions(project.functions);
  _DataTable["default"] === null || _DataTable["default"] === void 0 || _DataTable["default"].setTables(project.tables);
  (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || _Entry$aiLearning.load(project.learning);
  Entry.scene.addScenes(project.scenes);
  Entry.stage.initObjectContainers();
  Entry.container.setObjects(project.objects);
  Entry.FPS = project.speed ? project.speed : 60;
  _GEHelper.GEHelper.Ticker.setFPS(Entry.FPS);
  Entry.aiUtilizeBlocks = ((_project = project) === null || _project === void 0 ? void 0 : _project.aiUtilizeBlocks) || [];
  if (Entry.aiUtilizeBlocks.length > 0) {
    for (var type in Entry.ALL_AI_UTILIZE_BLOCK_LIST) {
      if (Entry.aiUtilizeBlocks.indexOf(type) > -1) {
        Entry.AI_UTILIZE_BLOCK[type].init();
        if (Entry.type === 'workspace' || Entry.type === 'playground') {
          Entry.playground.blockMenu.unbanClass(type);
        }
      }
    }
  }
  Entry.expansionBlocks = project.expansionBlocks || [];
  if (Entry.expansionBlocks.length > 0) {
    for (var _type in Entry.EXPANSION_BLOCK_LIST) {
      if (Entry.expansionBlocks.indexOf(_type) > -1) {
        Entry.EXPANSION_BLOCK[_type].init();
        if (Entry.type === 'workspace' || Entry.type === 'playground') {
          Entry.playground.blockMenu.unbanClass(_type);
        }
      }
    }
  }
  Entry.hardwareLiteBlocks = project.hardwareLiteBlocks || [];
  if (Entry.hardwareLiteBlocks.length > 0) {
    for (var _type2 in Entry.HARDWARE_LITE_LIST) {
      if (Entry.hardwareLiteBlocks.indexOf(_type2) > -1) {
        var module = Entry.HARDWARE_LITE_LIST[_type2];
        Entry.playground.addHardwareLiteModule(module);
      }
    }
  }
  if (!Entry.engine.projectTimer) {
    Entry.variableContainer.generateTimer();
  }
  if (Object.keys(Entry.container.inputValue).length === 0) {
    Entry.variableContainer.generateAnswer();
  }
  Entry.start();
  if (this.options.programmingMode) {
    var mode = this.options.programmingMode;
    if (Entry.Utils.isNumber(mode)) {
      var pMode = mode;
      mode = {};
      this.mode = mode;
      if (pMode == 0) {
        mode.boardType = Entry.Workspace.MODE_BOARD;
        mode.textType = -1;
      } else if (pMode == 1) {
        // Python in Text Coding
        mode.boardType = Entry.Workspace.MODE_VIMBOARD;
        mode.textType = Entry.Vim.TEXT_TYPE_PY;
        mode.runType = Entry.Vim.WORKSPACE_MODE;
      } else if (pMode == 2) {
        // Javascript in Text Coding
        mode.boardType = Entry.Workspace.MODE_VIMBOARD;
        mode.textType = Entry.Vim.TEXT_TYPE_JS;
        mode.runType = Entry.Vim.MAZE_MODE;
      }
      Entry.getMainWS().setMode(mode);
    }
  }
  Entry.Loader.isLoaded() && Entry.Loader.handleLoad();
  if (this.type == 'workspace') {
    Entry.stateManager.endIgnore();
  }
  if (project["interface"] && Entry.options.loadInterface) {
    Entry.loadInterfaceState(project["interface"]);
  }
  try {
    if (window.parent && window.parent.childIframeLoaded) {
      window.parent.childIframeLoaded();
    }
  } catch (e) {}
  Entry.isLoadProject = true;
  return project;
};
Entry.clearProject = function () {
  try {
    var _Entry$stateManager;
    Entry.stop();
    Entry.projectId = null;
    Entry.variableContainer.clear();
    Entry.container.clear();
    Entry.scene.clear();
    (_Entry$stateManager = Entry.stateManager) === null || _Entry$stateManager === void 0 || _Entry$stateManager.clear();
    _DataTable["default"] === null || _DataTable["default"] === void 0 || _DataTable["default"].clear();
    _GEHelper.GEHelper.resManager.clearProject();
    Entry.Loader && (Entry.Loader.loaded = false);
    if (Entry.type !== 'invisible') {
      Entry.playground && Entry.playground.changeViewMode('code');
    }
  } catch (e) {
    console.warn('clearProject fail', e);
  }
};

/**
 * Export project
 * @param {?Project} project
 */
Entry.exportProject = function (project) {
  var _Entry$aiLearning2;
  if (!project) {
    project = {};
  }
  if (!Entry.engine.isState('stop')) {
    Entry.engine.toggleStop();
  }
  project.objects = Entry.container.toJSON();
  var objects = project.objects;
  project.scenes = Entry.scene.toJSON();
  project.variables = Entry.variableContainer.getVariableJSON();
  project.messages = Entry.variableContainer.getMessageJSON();
  project.functions = Entry.variableContainer.getFunctionJSON();
  project.tables = _DataTable["default"].getTableJSON();
  project.speed = Entry.FPS;
  project["interface"] = Entry.captureInterfaceState();
  project.expansionBlocks = Entry.expansionBlocks;
  project.aiUtilizeBlocks = Entry.aiUtilizeBlocks;
  project.hardwareLiteBlocks = Entry.hardwareLiteBlocks;
  project.learning = (_Entry$aiLearning2 = Entry.aiLearning) === null || _Entry$aiLearning2 === void 0 ? void 0 : _Entry$aiLearning2.toJSON();
  project.externalModules = _entryModuleLoader["default"].moduleList;
  project.externalModulesLite = _entryModuleLoader["default"].moduleListLite;
  if (!objects || !objects.length) {
    return false;
  }
  return project;
};

/**
 * inject blocks to Entry menu.
 * Available block is different by object type.
 * @param {!string} objectType
 * @param {!xml} XML
 */
Entry.setBlock = function (objectType, XML) {
  Entry.playground.setMenuBlock(objectType, XML);
};

/**
 * This method is called when window closed;
 * @param {event} e
 */
Entry.beforeUnload = function (e) {
  Entry.dispatchEvent('EntryBeforeUnload');
  Entry.hw.closeConnection();
  if (Entry.type === 'workspace') {
    if (localStorage && Entry.interfaceState) {
      localStorage.setItem('workspace-interface', JSON.stringify(Entry.captureInterfaceState()));
    }
    if (!Entry.stateManager.isSaved()) {
      return Lang.Workspace.project_changed;
    }
  }
};
Entry.captureInterfaceState = function () {
  var interfaceState = JSON.parse(JSON.stringify(Entry.interfaceState));
  var playground = Entry.playground;
  if (Entry.type === 'workspace' && playground && playground.object) {
    interfaceState.object = playground.object.id;
  }
  return interfaceState;
};

/**
 * load interface state by localstorage
 */
Entry.loadInterfaceState = function (interfaceState) {
  if (Entry.type === 'workspace') {
    if (interfaceState) {
      Entry.container.selectObject(interfaceState.object, true);
    } else if (localStorage && localStorage.getItem('workspace-interface')) {
      var interfaceModel = localStorage.getItem('workspace-interface');
      interfaceState = JSON.parse(interfaceModel);
    } else {
      interfaceState = {
        menuWidth: 280,
        canvasWidth: 480
      };
    }
    this.resizeElement(interfaceState);
  }
};

/**
 * @return {Number} return up time time stamp
 */
Entry.getUpTime = function () {
  return new Date().getTime() - this.startTime;
};

/**
 * @param {String} activityType
 */
Entry.addActivity = function (activityType) {
  if (Entry.stateManager) {
    Entry.stateManager.addActivity(activityType);
  }
};
Entry.startActivityLogging = function () {
  if (Entry.reporter) {
    Entry.reporter.start(Entry.projectId, window.user ? window.user._id : null, Entry.startTime);
  }
};

/**
 * return activity log
 * @return {object}
 */
Entry.getActivityLog = function () {
  var log = {};
  if (Entry.stateManager) {
    log.activityLog = Entry.stateManager.activityLog_;
  }
  return log;
};
//block drag mode for Entry.BlockView
Entry.DRAG_MODE_NONE = 0;
Entry.DRAG_MODE_MOUSEDOWN = 1;
Entry.DRAG_MODE_DRAG = 2;
Entry.cancelObjectEdit = function (_ref) {
  var target = _ref.target,
    type = _ref.type;
  var object = Entry.playground.object;
  if (!object) {
    return;
  }
  var objectView = object.view_;
  var isCurrent = $(objectView).find(target).length !== 0;
  var tagName = target.tagName.toUpperCase();
  if (!object.isEditing || tagName === 'INPUT' && isCurrent || type === 'touchstart') {
    return;
  }
  object.editObjectValues(false);
};
Entry.getMainWS = function () {
  var ret;
  if (Entry.mainWorkspace) {
    ret = Entry.mainWorkspace;
  } else if (Entry.playground && Entry.playground.mainWorkspace) {
    ret = Entry.playground.mainWorkspace;
  }
  return ret;
};
Entry.getDom = function (query) {
  if (!query) {
    return this.view_;
  }
  query = JSON.parse(JSON.stringify(query));
  if (query.length > 1) {
    var key = query.shift();
    return this[key].getDom(query);
  } else {}
};
function toggleEngineContainer(isVisible) {
  var splitterSelector = '.entryObjectSelectedImgWorkspace';
  $(Entry.engineContainer).css('padding', isVisible ? '' : '0').children(":not(".concat(splitterSelector, ")")).toggleClass('entryRemove', !isVisible);
}

/**
 * Resize element's size.
 * @param {!json} interfaceModel
 */
Entry.resizeElement = function (interfaceModel) {
  // 워크 스페이스에 style width / height 값을 임시로 막음.
  // return;
  var mainWorkspace = Entry.getMainWS();
  if (!mainWorkspace) {
    return;
  }
  if (!interfaceModel) {
    interfaceModel = this.interfaceState;
  }
  if (Entry.type === 'workspace') {
    var interfaceState = this.interfaceState;
    if (!interfaceModel.canvasWidth && interfaceState.canvasWidth) {
      interfaceModel.canvasWidth = interfaceState.canvasWidth;
    }
    if (Entry.engine.speedPanelOn) {
      Entry.engine.toggleSpeedPanel();
    }
    var isEngineContainerVisible = true;
    var canvasSize = interfaceModel.canvasWidth;
    if (!canvasSize) {
      canvasSize = Entry.CANVAS_MIN_WIDTH;
    } else if (canvasSize < Entry.CANVAS_MIN_WIDTH) {
      canvasSize = 16;
      isEngineContainerVisible = false;
    } else if (canvasSize < Entry.CANVAS_DEFAULT_WIDTH) {
      canvasSize = Entry.CANVAS_DEFAULT_WIDTH;
    } else if (canvasSize > Entry.CANVAS_MAX_WIDTH) {
      canvasSize = Entry.CANVAS_MAX_WIDTH;
    }
    interfaceModel.canvasWidth = canvasSize;
    var engineContainer = Entry.engine.view_.parentElement;
    engineContainer.style.width = "".concat(canvasSize, "px");
    Entry.engine.view_.style.width = "".concat(canvasSize - 24, "px");
    Entry.stage.canvas.canvas.style.width = "".concat(canvasSize - 26, "px");
    toggleEngineContainer(isEngineContainerVisible);
    var blockMenu = mainWorkspace.blockMenu;
    var adjust = blockMenu.hasCategory() ? -64 : 0;
    this.interfaceState = interfaceModel;
  }
  Entry.windowResized.notify();
};

/**
 * override native prototype to add useful method.
 */
Entry.overridePrototype = function () {
  /** modulo include negative number */
  Number.prototype.mod = function (n) {
    try {
      // 음수 보정을 위해서 존재하는 기능
      // INFO : https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers
      var left = (0, _mathjs.bignumber)(this);
      var right = (0, _mathjs.bignumber)(n);
      return (0, _mathjs.chain)(left).mod(right).add(right).mod(right).value.toNumber();
    } catch (e) {
      return (this % n + n) % n;
    }
  };

  //polyfill
  if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
      'use strict';

      if (this == null) {
        throw new TypeError("can't convert ".concat(this, " to object"));
      }
      var str = "".concat(this);
      count = +count;
      if (count != count) {
        count = 0;
      }
      if (count < 0) {
        throw new RangeError('repeat count must be non-negative');
      }
      if (count == Infinity) {
        throw new RangeError('repeat count must be less than infinity');
      }
      count = Math.floor(count);
      if (str.length == 0 || count == 0) {
        return '';
      }
      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) {
        throw new RangeError('repeat count must not overflow maximum string size');
      }
      var rpt = '';
      for (;;) {
        if ((count & 1) == 1) {
          rpt += str;
        }
        count >>>= 1;
        if (count == 0) {
          break;
        }
        str += str;
      }
      // Could we try:
      // return Array(count + 1).join(this);
      return rpt;
    };
  }
};

// INFO: 기존에 사용하던 isNaN에는 숫자 체크의 문자가 있을수 있기때문에 regex로 체크하는 로직으로 변경
// isNaN 문제는 https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/isNaN
// 에서 확인.
Entry.Utils.isNumber = function (num) {
  if (typeof num === 'number') {
    return true;
  }
  var reg = /^-?\d+\.?\d*$/;
  if (typeof num === 'string' && reg.test(num)) {
    return true;
  }
  return false;
};
Entry.Utils.generateId = function () {
  return "0000".concat((Math.random() * Math.pow(36, 4) << 0).toString(36)).substr(-4);
};
Entry.Utils.randomColor = function () {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
Entry.Utils.isPointInMatrix = function (matrix, point, offset) {
  offset = offset === undefined ? 0 : offset;
  var x = matrix.offsetX ? matrix.x + matrix.offsetX : matrix.x;
  var y = matrix.offsetY ? matrix.y + matrix.offsety : matrix.y;
  return x - offset <= point.x && x + matrix.width + offset >= point.x && y - offset <= point.y && y + matrix.height + offset >= point.y;
};
Entry.Utils.colorDarken = function (color, factor) {
  var r;
  var g;
  var b;
  if (color.length === 7) {
    r = parseInt(color.substr(1, 2), 16);
    g = parseInt(color.substr(3, 2), 16);
    b = parseInt(color.substr(5, 2), 16);
  } else {
    r = parseInt(color.substr(1, 2), 16);
    g = parseInt(color.substr(2, 2), 16);
    b = parseInt(color.substr(3, 2), 16);
  }
  factor = factor === undefined ? 0.7 : factor;
  r = inspect(Math.floor(r * factor).toString(16));
  g = inspect(Math.floor(g * factor).toString(16));
  b = inspect(Math.floor(b * factor).toString(16));
  function inspect(val) {
    if (val.length != 2) {
      val = "0".concat(val);
    }
    return val;
  }
  return "#".concat(r).concat(g).concat(b);
};
Entry.Utils.colorLighten = function (color, amount) {
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }
  amount = amount === 0 ? 0 : amount || 20;
  var hsl = Entry.Utils.hexToHsl(color);
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return Entry.Utils.hslToHex(hsl);
};
Entry.Utils.getEmphasizeColor = function (color) {
  return EntryStatic.colorSet.block.emphasize[color] || color;
};

// Take input from [0, n] and return it as [0, 1]
Entry.Utils.bound01 = function (n, max) {
  function isOnePointZero(n) {
    return typeof n === 'string' && n.indexOf('.') != -1 && parseFloat(n) === 1;
  }
  function isPercentage(n) {
    return typeof n === 'string' && n.indexOf('%') != -1;
  }
  if (isOnePointZero(n)) {
    n = '100%';
  }
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));

  // Automatically convert percentage into number
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return n % max / parseFloat(max);
};

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
Entry.Utils.hexToHsl = function (color) {
  var r;
  var g;
  var b;
  if (color.length === 7) {
    r = parseInt(color.substr(1, 2), 16);
    g = parseInt(color.substr(3, 2), 16);
    b = parseInt(color.substr(5, 2), 16);
  } else {
    r = parseInt(color.substr(1, 2), 16);
    g = parseInt(color.substr(2, 2), 16);
    b = parseInt(color.substr(3, 2), 16);
  }
  r = Entry.Utils.bound01(r, 255);
  g = Entry.Utils.bound01(g, 255);
  b = Entry.Utils.bound01(b, 255);
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h;
  var s;
  var l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  var hsl = {
    h: h,
    s: s,
    l: l
  };
  return {
    h: hsl.h * 360,
    s: hsl.s,
    l: hsl.l
  };
};

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
Entry.Utils.hslToHex = function (color) {
  var r;
  var g;
  var b;
  var h = Entry.Utils.bound01(color.h, 360);
  var s = Entry.Utils.bound01(color.s, 1);
  var l = Entry.Utils.bound01(color.l, 1);
  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }
  function pad2(c) {
    return c.length == 1 ? "0".concat(c) : "".concat(c);
  }
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  var rgb = {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
  var hex = [pad2(Math.round(rgb.r).toString(16)), pad2(Math.round(rgb.g).toString(16)), pad2(Math.round(rgb.b).toString(16))];
  return "#".concat(hex.join(''));
};
Entry.Utils.setSVGDom = function (SVGDom) {
  Entry.Utils.SVGDom = SVGDom;
};
Entry.Utils.bindIOSDeviceWatch = function () {
  var Agent = Entry.Utils.mobileAgentParser();
  if (Agent.apple.device) {
    var lastHeight = window.innerHeight || document.documentElement.clientHeight;
    var lastSVGDomHeight = 0;
    if (Entry.Utils.SVGDom) {
      lastSVGDomHeight = Entry.Utils.SVGDom.height();
    }
    setInterval(function () {
      var nowHeight = window.innerHeight || document.documentElement.clientHeight;
      var SVGDomCheck = false;
      if (Entry.Utils.SVGDom) {
        var nowSVGDomHeight = Entry.Utils.SVGDom.height();
        SVGDomCheck = lastSVGDomHeight != nowSVGDomHeight;
        lastSVGDomHeight = nowSVGDomHeight;
      }
      if (lastHeight != nowHeight || SVGDomCheck) {
        Entry.windowResized.notify();
      }
      lastHeight = nowHeight;
    }, 1000);
    $(window).on('orientationchange', function () {
      Entry.windowResized.notify();
    });
    window.addEventListener('pagehide', Entry.beforeUnload);
  }
};
function addEntryEvent(dom, event, func) {
  if (dom && event) {
    dom.on(event, func);
  }
}
function removeEntryEvent(dom, event, func) {
  if (dom && event) {
    dom.off(event, func);
  }
}
Entry.Utils.bindGlobalEvent = function (options) {
  var doc = $(document);
  var parentDoc;
  if (window.parent !== window.self) {
    try {
      parentDoc = $(window.parent.document);
    } catch (e) {}
  }
  if (options === undefined) {
    options = ['resize', 'mousedown', 'mousemove', 'keydown', 'keyup', 'dispose'];
  }
  if (options.indexOf('resize') > -1) {
    if (Entry.windowReszied) {
      removeEntryEvent($(window), 'resize');
      if (parentDoc) {
        removeEntryEvent($(window.parent), 'resize');
      }
      Entry.windowReszied.clear();
    }
    Entry.windowResized = new Entry.Event(window);
    var func = function func(e) {
      Entry.windowResized.notify(e);
    };
    addEntryEvent($(window), 'resize', func);
    if (parentDoc) {
      addEntryEvent($(window.parent), 'resize', func);
    }
    Entry.Utils.bindIOSDeviceWatch();
  }
  if (options.indexOf('mousedown') > -1) {
    if (Entry.documentMousedown) {
      removeEntryEvent(doc, 'mousedown');
      removeEntryEvent(parentDoc, 'mousedown');
      Entry.documentMousedown.clear();
    }
    Entry.documentMousedown = new Entry.Event(window);
    var _func = function _func(e) {
      var selectedBlock = document.querySelector('.block.selected');
      if (selectedBlock) {
        selectedBlock.classList.remove('selected');
      }
    };
    addEntryEvent(doc, 'mousedown', _func);
    addEntryEvent(parentDoc, 'mousedown', _func);
  }
  if (options.indexOf('mousemove') > -1) {
    if (Entry.documentMousemove) {
      removeEntryEvent(doc, 'touchmove mousemove');
      removeEntryEvent(parentDoc, 'touchmove mousemove');
      Entry.documentMousemove.clear();
    }
    Entry.mouseCoordinate = {};
    Entry.documentMousemove = new Entry.Event(window);
    var _func2 = function _func2(e) {
      if (e.originalEvent && e.originalEvent.touches) {
        e = e.originalEvent.touches[0];
      }
      Entry.documentMousemove.notify(e);
      Entry.mouseCoordinate.x = e.clientX;
      Entry.mouseCoordinate.y = e.clientY;
    };
    addEntryEvent(doc, 'touchmove mousemove', _func2);
    addEntryEvent(parentDoc, 'touchmove mousemove', _func2);
  }
  if (options.indexOf('keydown') > -1) {
    if (Entry.keyPressed) {
      removeEntryEvent(doc, 'keydown');
      removeEntryEvent(parentDoc, 'keydown');
      Entry.keyPressed.clear();
    }
    Entry.pressedKeys = [];
    Entry.keyPressed = new Entry.Event(window);
    var _func3 = function _func3(e) {
      var keyCode = Entry.Utils.inputToKeycode(e);
      if (!keyCode) {
        return;
      }
      if (Entry.pressedKeys.indexOf(keyCode) < 0) {
        Entry.pressedKeys.push(keyCode);
      }
      Entry.keyPressed.notify(e);
    };
    addEntryEvent(doc, 'keydown', _func3);
    addEntryEvent(parentDoc, 'keydown', _func3);
  }
  if (options.indexOf('keyup') > -1) {
    if (Entry.keyUpped) {
      removeEntryEvent(doc, 'keyup');
      removeEntryEvent(parentDoc, 'keyup');
      Entry.keyUpped.clear();
    }
    Entry.keyUpped = new Entry.Event(window);
    var _func4 = function _func4(e) {
      var keyCode = Entry.Utils.inputToKeycode(e);
      if (!keyCode) {
        return;
      }
      var index = Entry.pressedKeys.indexOf(keyCode);
      if (index > -1) {
        Entry.pressedKeys.splice(index, 1);
      }
      Entry.keyUpped.notify(e);
    };
    addEntryEvent(doc, 'keyup', _func4);
    addEntryEvent(parentDoc, 'keyup', _func4);
  }
  if (options.indexOf('dispose') > -1) {
    if (Entry.disposeEvent) {
      Entry.disposeEvent.clear();
    }
    Entry.disposeEvent = new Entry.Event(window);
    if (Entry.documentMousedown) {
      Entry.documentMousedown.attach(this, function (e) {
        Entry.disposeEvent.notify(e);
      });
    }
  }
};
Entry.Utils.inputToKeycode = function (e) {
  //https://riptutorial.com/jquery/example/21119/originalevent
  var event = e.originalEvent || e;
  var keyCode = event.code == undefined ? event.key : event.code;
  if (!keyCode) {
    return null;
  }
  keyCode = keyCode.replace('Digit', '');
  keyCode = keyCode.replace('Numpad', '');
  if (keyCode.indexOf('Shift') > -1) {
    keyCode = keyCode.replace('Left', '');
    keyCode = keyCode.replace('Right', '');
  }
  return Entry.KeyboardCode.codeToKeyCode[keyCode];
};
Entry.Utils.makeActivityReporter = function () {
  Entry.activityReporter = new Entry.ActivityReporter();
  if (Entry.commander) {
    Entry.commander.addReporter(Entry.activityReporter);
  }
  return Entry.activityReporter;
};

/**
 * Raise error when assert condition fail.
 * @param {!boolean} condition assert condition.
 * @param {?string} message assert message will be shown when assert fail.
 */
Entry.assert = function (condition, message) {
  if (!condition) {
    throw Error(message || 'Assert failed');
  }
};

/**
 * Parse Text to Xml
 * @param {!string} xmlText
 * @param {xml} doc
 */
Entry.parseTexttoXML = function (xmlText) {
  var doc;
  if (window.ActiveXObject) {
    doc = new ActiveXObject('Microsoft.XMLDOM');
    doc.async = 'false';
    doc.loadXML(xmlText);
  } else {
    var parser = new DOMParser();
    doc = parser.parseFromString(xmlText, 'text/xml');
  }
  return doc;
};

/**
 * Create html element with some method
 */
Entry.createElement = function (type, elementId) {
  var element = type instanceof HTMLElement ? type : document.createElement(type);
  if (elementId) {
    element.id = elementId;
  }
  return element;
};

/**
 * Generate random hash
 * @return {string}
 */
Entry.generateHash = function () {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  return Math.random().toString(36).substr(2, length);
};

/**
 * Add two number properly.
 *
 * @return {number}
 *
 * @param {!number} a
 * @param {!number} b
 */
Entry.addTwoNumber = function (a, b) {
  if (!Entry.Utils.isNumber(a) || !Entry.Utils.isNumber(b)) {
    return a + b;
  }
  a += '';
  b += '';
  var indexA = a.indexOf('.');
  var indexB = b.indexOf('.');
  var fixedA = 0;
  var fixedB = 0;
  if (indexA > 0) {
    fixedA = a.length - indexA - 1;
  }
  if (indexB > 0) {
    fixedB = b.length - indexB - 1;
  }
  if (fixedA > 0 || fixedB > 0) {
    if (fixedA >= fixedB) {
      return (parseFloat(a) + parseFloat(b)).toFixed(fixedA);
    } else {
      return (parseFloat(a) + parseFloat(b)).toFixed(fixedB);
    }
  } else {
    return parseInt(a) + parseInt(b);
  }
};

/*
 * HTML hex colour code to RGB colour value
 */
Entry.hex2rgb = function (hexstr) {
  var hex = hexstr[0] === '#' ? hexstr : "#".concat(hexstr);
  if (hex.length === 4) {
    hex = "#".concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]).concat(hex[3]).concat(hex[3]);
  }
  if (!/^#[0-9a-f]{6}?$/i.test(hex)) {
    hex = '#000000';
  }
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/*
 * RGB colour value to HTML hex colour code
 */
Entry.rgb2hex = function (r, g, b) {
  return "#".concat(((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1));
};

/**
 *
 * @param {number} r - 0~255 integer
 * @param {number} g - 0~255 integer
 * @param {number} b - 0~255 integer
 * @return {number} 0~0xffffff integer
 */
Entry.rgb2Number = function (r, g, b) {
  return (r << 16) + (g << 8) + Number(b);
};

/*
 * Generate random rgb color object
 */
Entry.generateRgb = function () {
  return {
    r: Math.floor(Math.random() * 256),
    g: Math.floor(Math.random() * 256),
    b: Math.floor(Math.random() * 256)
  };
};

/*
 * Adjustment input value by max and min value
 * @param {!Number} value, min, max
 */
Entry.adjustValueWithMaxMin = function (input, min, max) {
  if (input > max) {
    return max;
  } else if (input < min) {
    return min;
  } else {
    return input;
  }
};

/*
 * Inspect input value exists already in an array
 * @param {String} targetValue
 * @param {String} identifier
 * @param {Array} arr
 * @return {boolean} return true when target value exists already
 */
Entry.isExist = function (targetValue, identifier, arr) {
  return !!_.find(arr, (0, _defineProperty2["default"])({}, identifier, targetValue));
};
Entry.getColourCodes = function () {
  return ['transparent', '#660000', '#663300', '#996633', '#003300', '#003333', '#003399', '#000066', '#330066', '#660066', '#FFFFFF', '#990000', '#993300', '#CC9900', '#006600', '#336666', '#0033FF', '#000099', '#660099', '#990066', '#000000', '#CC0000', '#CC3300', '#FFCC00', '#009900', '#006666', '#0066FF', '#0000CC', '#663399', '#CC0099', '#333333', '#FF0000', '#FF3300', '#FFFF00', '#00CC00', '#009999', '#0099FF', '#0000FF', '#9900CC', '#FF0099', '#666666', '#CC3333', '#FF6600', '#FFFF33', '#00FF00', '#00CCCC', '#00CCFF', '#3366FF', '#9933FF', '#FF00FF', '#999999', '#FF6666', '#FF6633', '#FFFF66', '#66FF66', '#66CCCC', '#00FFFF', '#3399FF', '#9966FF', '#FF66FF', '#BBBBBB', '#FF9999', '#FF9966', '#FFFF99', '#99FF99', '#66FFCC', '#99FFFF', '#66CCff', '#9999FF', '#FF99FF', '#CCCCCC', '#FFCCCC', '#FFCC99', '#FFFFCC', '#CCFFCC', '#99FFCC', '#CCFFFF', '#99CCFF', '#CCCCFF', '#FFCCFF'];
};

/*
 * Replacement for element.remove() method
 * @param {Element} targetElement
 * @return {boolean} return true when target element remove or not
 */
Entry.removeElement = function (element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
};

/*
 * parse string to number
 * @param {String||Number} value
 * @return {Boolean||Number} arr
 */
Entry.parseNumber = function (value) {
  if (typeof value === 'string') {
    if (Entry.Utils.isNumber(value) && value[0] === '0' || value[0] === '0' && value[1].toLowerCase() === 'x') {
      return value;
    } else if (Entry.Utils.isNumber(value)) {
      return Number(value);
    }
  } else if (typeof value === 'number' && Entry.Utils.isNumber(value)) {
    return value;
  }
  return false;
};

/**
 * count length of string.
 * Hanguel character is count to two.
 * @param {!String} dataString
 * @return {Number}
 */
Entry.countStringLength = function (dataString) {
  var p;
  var len = 0;
  for (p = 0; p < dataString.length; p++) {
    if (dataString.charCodeAt(p) > 255) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
};

/**
 * count length of string.
 * Hanguel character is count to two.
 * @param {!String} dataString
 * @param {!Number} stringLength
 * @return {String}
 */
Entry.cutStringByLength = function (dataString, stringLength) {
  var p;
  var len = 0;
  for (p = 0; len < stringLength && p < dataString.length; p++) {
    if (dataString.charCodeAt(p) > 255) {
      len += 2;
    } else {
      len++;
    }
  }
  return dataString.substr(0, p);
};

/**
 * check to element is are parent child.
 * @param {Element} parent
 * @param {Element} child
 * @return {Boolean}
 */
Entry.isChild = function (parent, child) {
  if (!child) {
    while (child.parentNode) {
      if ((child = child.parentNode) == parent) {
        return true;
      }
    }
  }
  return false;
};

/**
 * @param {Element} child
 */
Entry.launchFullScreen = function (element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFulScreen) {
    element.mozRequestFulScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullScreen) {
    element.msRequestFullScreen();
  }
};
Entry.exitFullScreen = function () {
  if (document.exitFullScreen) {
    document.exitFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
};
Entry.isPhone = function () {
  return false;
  //if (window.screen.availWidth > 480)
  //return false;
  //else
  //return true;
};
Entry.getKeyCodeMap = function () {
  return {
    8: 'backspace',
    9: 'tab',
    13: Lang.Blocks.START_press_some_key_enter,
    16: 'shift',
    17: 'ctrl',
    18: 'alt',
    27: 'esc',
    32: Lang.Blocks.START_press_some_key_space,
    37: Lang.Blocks.START_press_some_key_left,
    38: Lang.Blocks.START_press_some_key_up,
    39: Lang.Blocks.START_press_some_key_right,
    40: Lang.Blocks.START_press_some_key_down,
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    65: 'a',
    66: 'b',
    67: 'c',
    68: 'd',
    69: 'e',
    70: 'f',
    71: 'g',
    72: 'h',
    73: 'i',
    74: 'j',
    75: 'k',
    76: 'l',
    77: 'm',
    78: 'n',
    79: 'o',
    80: 'p',
    81: 'q',
    82: 'r',
    83: 's',
    84: 't',
    85: 'u',
    86: 'v',
    87: 'w',
    88: 'x',
    89: 'y',
    90: 'z',
    //special Characters
    186: ';',
    187: '=',
    188: ',',
    189: '-',
    190: '.',
    191: '/',
    192: '~',
    219: '[',
    220: 'Backslash',
    221: ']',
    222: "'"
    // #2590 이슈 처리에 의해 주석처리
    // '45': 'Help',
    // '45': 'Insert',
    // '46': 'Delete',
    // '36': 'Home',
    // '35': 'End',
    // '33': 'PageUp',
    // '34': 'PageDown',
  };
};
Entry.checkCollisionRect = function (rectA, rectB) {
  return !(rectA.y + rectA.height < rectB.y || rectA.y > rectB.y + rectB.height || rectA.x + rectA.width < rectB.x || rectA.x > rectB.x + rectB.width);
};
Entry.bindAnimationCallback = function (element, func) {
  element.addEventListener('webkitAnimationEnd', func, false);
  element.addEventListener('animationend', func, false);
  element.addEventListener('oanimationend', func, false);
};
Entry.cloneSimpleObject = function (object) {
  return _.clone(object);
};
Entry.computeInputWidth = function () {
  var elem;
  var _cache = {};
  return function (value) {
    // eslint-disable-next-line no-param-reassign
    value = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var cached = _cache[value];
    if (cached) {
      return cached;
    } else {
      elem = elem || document.getElementById('entryInputForComputeWidth');
      if (!elem) {
        elem = document.createElement('span');
        elem.setAttribute('id', 'entryInputForComputeWidth');
        elem.className = 'elem-element';
        document.body.appendChild(elem);
      }
      elem.textContent = value;
      var ret = "".concat(Number(elem.offsetWidth + 10), "px");
      if (window.fontLoaded) {
        _cache[value] = ret;
      }
      return ret;
    }
  };
}();
Entry.isArrowOrBackspace = function (keyCode) {
  return !!~['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace'].indexOf(keyCode);
};
Entry.hexStringToBin = function (hexString) {
  var bytes = [];
  var str;
  for (var i = 0; i < hexString.length - 1; i += 2) {
    bytes.push(parseInt(hexString.substr(i, 2), 16));
  }
  str = String.fromCharCode.apply(String, bytes);
  return str;
};

//maybe deprecated
Entry.findObjsByKey = function (arr, keyName, key) {
  var result = [];
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][keyName] == key) {
      result.push(arr[i]);
    }
  }
  return result;
};
Entry.factorial = _.memoize(function (n) {
  if (n === 0 || n == 1) {
    return 1;
  }
  return Entry.factorial(n - 1) * n;
});
Entry.getListRealIndex = function (index, list) {
  if (!Entry.Utils.isNumber(index)) {
    switch (index) {
      case 'FIRST':
        index = 1;
        break;
      case 'LAST':
        index = list.getArray().length;
        break;
      case 'RANDOM':
        index = Math.floor(Math.random() * list.getArray().length) + 1;
        break;
    }
  }
  return index;
};
Entry.toRadian = function (angle) {
  return angle * Math.PI / 180;
};
Entry.toDegrees = function (radians) {
  return radians * 180 / Math.PI;
};
var SQRT3 = Math.sqrt(3);
var TRIG_VALUES = {
  sin: {
    0: 0,
    30: 0.5,
    45: Math.SQRT2 / 2,
    60: SQRT3 / 2,
    90: 1,
    120: SQRT3 / 2,
    135: Math.SQRT2 / 2,
    150: 0.5,
    180: 0,
    210: -0.5,
    225: -Math.SQRT2 / 2,
    240: -SQRT3 / 2,
    270: -1,
    300: -SQRT3 / 2,
    315: -Math.SQRT2 / 2,
    330: -0.5,
    360: 0
  },
  cos: {
    0: 1,
    30: SQRT3 / 2,
    45: Math.SQRT2 / 2,
    60: 0.5,
    90: 0,
    120: -0.5,
    135: -Math.SQRT2 / 2,
    150: -SQRT3 / 2,
    180: -1,
    210: -SQRT3 / 2,
    225: -Math.SQRT2 / 2,
    240: -0.5,
    270: 0,
    300: 0.5,
    315: Math.SQRT2 / 2,
    330: SQRT3 / 2,
    360: 1
  },
  tan: {
    0: 0,
    30: SQRT3 / 3,
    45: 1,
    60: SQRT3,
    90: Infinity,
    120: -SQRT3,
    135: -1,
    150: -SQRT3 / 3,
    180: 0,
    210: SQRT3 / 3,
    225: 1,
    240: SQRT3,
    270: -Infinity,
    300: -SQRT3,
    315: -1,
    330: -SQRT3 / 3,
    360: 0
  }
};
Entry.preciseTrig = function (degrees, operator) {
  var angle = degrees % 360;
  if (TRIG_VALUES[operator] && Object.prototype.hasOwnProperty.call(TRIG_VALUES[operator], angle)) {
    return TRIG_VALUES[operator][angle];
  }
  return Math[operator](Entry.toRadian(angle));
};
Entry.getPicturesJSON = function () {
  var pictures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isClone = arguments.length > 1 ? arguments[1] : undefined;
  return pictures.reduce(function (acc, p) {
    var o = {};
    o._id = p._id;
    o.id = isClone ? Entry.generateHash() : p.id;
    o.dimension = p.dimension;
    o.filename = p.filename;
    o.fileurl = p.fileurl;
    o.thumbUrl = p.thumbUrl;
    o.name = p.name;
    o.scale = p.scale;
    o.imageType = p.imageType || 'png';
    acc.push(o);
    return acc;
  }, []);
};
Entry.getSoundsJSON = function () {
  var sounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isClone = arguments.length > 1 ? arguments[1] : undefined;
  return sounds.reduce(function (acc, s) {
    var o = {};
    o._id = s._id;
    o.duration = s.duration;
    o.ext = s.ext;
    o.id = isClone ? Entry.generateHash() : s.id;
    o.filename = s.filename;
    o.fileurl = s.fileurl;
    o.name = s.name;
    acc.push(o);
    return acc;
  }, []);
};
Entry.cutDecimal = function (number) {
  return Math.round(number * 100) / 100;
};
Entry.getBrowserType = function () {
  if (Entry.userAgent) {
    return Entry.userAgent;
  }
  var ua = navigator.userAgent;
  var tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE ".concat(tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  var uaResult = M.join(' ');
  Entry.userAgent = uaResult;
  return uaResult;
};
Entry.setBasicBrush = function (sprite) {
  var isWebGL = _GEHelper.GEHelper.isWebGL;
  var brush = _GEHelper.GEHelper.brushHelper.newBrush();
  if (sprite.brush) {
    var parentBrush = sprite.brush;
    brush.thickness = parentBrush.thickness;
    brush.rgb = parentBrush.rgb;
    brush.opacity = parentBrush.opacity;
    brush.setStrokeStyle(brush.thickness);
    var rgb = brush.rgb;
    var opacity = 1 - brush.opacity / 100;
    if (isWebGL) {
      brush.beginStrokeFast(Entry.rgb2Number(rgb.r, rgb.g, rgb.b), opacity);
    } else {
      brush.beginStroke("rgba(".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b, ",").concat(opacity, ")"));
    }
  } else {
    brush.thickness = 1;
    brush.rgb = Entry.hex2rgb('#ff0000');
    brush.opacity = 0;
    brush.setStrokeStyle(1);
    if (isWebGL) {
      brush.beginStrokeFast(0xff0000, 1);
    } else {
      brush.beginStroke('rgba(255,0,0,1)');
    }
  }
  brush.entity = sprite;
  var shape = _GEHelper.GEHelper.brushHelper.newShape(brush);
  shape.entity = sprite;
  var selectedObjectContainer = Entry.stage.selectedObjectContainer;
  selectedObjectContainer.addChildAt(shape, selectedObjectContainer.getChildIndex(sprite.object));
  sprite.brush = brush;
  sprite.shapes.push(shape);
};
Entry.setCloneBrush = function (sprite, parentBrush) {
  var isWebGL = _GEHelper.GEHelper.isWebGL;
  var brush = _GEHelper.GEHelper.brushHelper.newBrush();
  brush.thickness = parentBrush.thickness;
  brush.rgb = parentBrush.rgb;
  brush.opacity = parentBrush.opacity;
  brush.setStrokeStyle(brush.thickness);
  var rgb = brush.rgb;
  var opacity = 1 - brush.opacity / 100;
  if (isWebGL) {
    brush.beginStrokeFast(Entry.rgb2Number(rgb.r, rgb.g, rgb.b), opacity);
  } else {
    brush.beginStroke("rgba(".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b, ",").concat(opacity, ")"));
  }
  var shape = _GEHelper.GEHelper.brushHelper.newShape(brush);
  shape.entity = sprite;
  var selectedObjectContainer = Entry.stage.selectedObjectContainer;
  selectedObjectContainer.addChildAt(shape, selectedObjectContainer.getChildIndex(sprite.object));
  brush.stop = parentBrush.stop;
  sprite.brush = brush;
  sprite.shapes.push(shape);
};
Entry.setBasicPaint = function (sprite) {
  var isWebGL = _GEHelper.GEHelper.isWebGL;
  var paint = _GEHelper.GEHelper.brushHelper.newPaint();
  var shape = _GEHelper.GEHelper.brushHelper.newShape(paint);
  paint.entity = sprite;
  paint.opacity = 0;
  paint.rgb = Entry.hex2rgb('#ff0000');
  if (isWebGL) {
    paint.beginFillFast(0xff0000, 1);
  } else {
    paint.beginFill('rgba(255,0,0,1)');
  }
  shape.entity = sprite;
  var selectedObjectContainer = Entry.stage.selectedObjectContainer;
  selectedObjectContainer.addChildAt(shape, selectedObjectContainer.getChildIndex(sprite.object));
  sprite.paint = paint;
  sprite.paintShapes.push(shape);
};
Entry.isFloat = function (num) {
  return /\d+\.{1}\d+$/.test(num);
};
Entry.isInteger = function (value) {
  return isFinite(value) && Math.floor(value) == value;
};
Entry.getStringIndex = function (str) {
  if (!str) {
    return '';
  }
  var result = {
    string: str,
    index: 1
  };
  var idx = 0;
  var num = [];
  var len = str.length;
  for (var i = len - 1; i > 0; --i) {
    var ch = str.charAt(i);
    if (Entry.Utils.isNumber(ch)) {
      num.unshift(ch);
      idx = i;
    } else {
      break;
    }
  }
  if (idx > 0) {
    result.string = str.substring(0, idx);
    result.index = parseInt(num.join('')) + 1;
  }
  return result;
};
Entry.getOrderedName = function (str, objects, field) {
  if (!str) {
    return 'untitled';
  }
  if (!objects || objects.length === 0) {
    return str;
  }
  if (!field) {
    field = 'name';
  }
  var maxNumber = Entry.getOrderedNameNumber(str, objects, field);
  var source = Entry.getStringIndex(str);
  if (maxNumber > 0) {
    return source.string + maxNumber;
  }
  return str;
};
Entry.getOrderedNameNumber = function (str, objects, field) {
  var source = Entry.getStringIndex(str);
  var maxNumber = 0;
  for (var i = 0, len = objects.length; i < len; i++) {
    var target = Entry.getStringIndex(objects[i][field]);
    if (source.string === target.string && target.index > maxNumber) {
      maxNumber = target.index;
    }
  }
  return maxNumber;
};
Entry.changeXmlHashId = function (xmlBlock) {
  var reg = /function_field/;
  if (reg.test(xmlBlock.getAttribute('type'))) {
    var mutations = xmlBlock.getElementsByTagName('mutation');
    for (var i = 0, len = mutations.length; i < len; i++) {
      mutations[i].setAttribute('hashid', Entry.generateHash());
    }
  }
  return xmlBlock;
};
Entry.getMaxFloatPoint = function (numbers) {
  var max = 0;
  for (var i = 0, len = numbers.length; i < len; i++) {
    var n = String(numbers[i]);
    var idx = n.indexOf('.');
    if (idx !== -1) {
      var tmp = n.length - (idx + 1);
      if (tmp > max) {
        max = tmp;
      }
    }
  }
  return Math.min(max, 20);
};
Entry.convertToRoundedDecimals = function (value, decimals) {
  if (!Entry.Utils.isNumber(value) || !this.isFloat(value)) {
    return value;
  } else {
    return Number("".concat(Math.round("".concat(value, "e").concat(decimals)), "e-").concat(decimals));
  }
};
Entry.attachEventListener = function (elem, eventType, func) {
  setTimeout(function () {
    elem.addEventListener(eventType, func);
  }, 0);
};
Entry.deAttachEventListener = function (elem, eventType, func) {
  elem.removeEventListener(eventType, func);
};
Entry.isEmpty = _.isEmpty;
Entry.Utils.disableContextmenu = function (node) {
  if (!node) {
    return;
  }
  $(node).on('contextmenu', this.contextPreventFunction);
};
Entry.Utils.contextPreventFunction = function (e) {
  e.stopPropagation();
  e.preventDefault();
  return false;
};
Entry.Utils.enableContextmenu = function (node) {
  if (!node) {
    return;
  }
  $(node).off('contextmenu', this.contextPreventFunction);
};
Entry.Utils.isRightButton = function (e) {
  return e.button == 2 || e.ctrlKey;
};
Entry.Utils.isTouchEvent = function (_ref2) {
  var type = _ref2.type;
  return type.toLowerCase().includes('touch');
};
Entry.Utils.inherit = function (parent, child) {
  function F() {}
  F.prototype = parent.prototype;
  child.prototype = new F();
  return child;
};
Entry.bindAnimationCallbackOnce = function ($elem, func) {
  $elem.one('webkitAnimationEnd animationendo animationend', func);
};
Entry.Utils.isInInput = function (_ref3) {
  var type = _ref3.target.type;
  return type === 'textarea' || type === 'text' || type === 'number';
};
Entry.Utils.addFilters = function (boardSvgDom, suffix, isOnlyBlock) {
  var defs = boardSvgDom.elem('defs');

  //trashcan filter
  var trashCanFilter = defs.elem('filter', {
    id: "entryTrashcanFilter_".concat(suffix)
  });
  trashCanFilter.elem('feGaussianBlur', {
    "in": 'SourceAlpha',
    stdDeviation: 2,
    result: 'blur'
  });
  trashCanFilter.elem('feOffset', {
    "in": 'blur',
    dx: 1,
    dy: 1,
    result: 'offsetBlur'
  });
  trashCanFilter.elem('feColorMatrix', {
    id: 'recolor',
    "in": 'offsetBlur',
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0',
    result: 'colorMatrix'
  });
  var feMerge = trashCanFilter.elem('feMerge');
  feMerge.elem('feMergeNode', {
    "in": 'colorMatrix'
  });
  feMerge.elem('feMergeNode', {
    "in": 'SourceGraphic'
  }, feMerge);
  var blockSelectFilter = defs.elem('filter', {
    id: "entryBlockSelectFilter_".concat(suffix)
  });
  blockSelectFilter.elem('feGaussianBlur', {
    id: 'blur',
    "in": 'SourceGraphic',
    stdDeviation: '1',
    result: 'blur'
  });
  var fct = blockSelectFilter.elem('feComponentTransfer', {
    "in": 'blur',
    result: 'component'
  });
  fct.elem('feFuncA', {
    id: 'contour',
    type: 'table',
    tableValues: '0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1'
  });
  blockSelectFilter.elem('feColorMatrix', {
    id: 'recolor',
    "in": 'component',
    type: 'matrix',
    values: '0 0 0 0 1 0 0 0 0 0.902 0 0 0 0 0 0 0 0 1 0',
    result: 'colorMatrix'
  });
  var fm = blockSelectFilter.elem('feMerge');
  fm.elem('feMergeNode', {
    "in": 'colorMatrix'
  });
  fm.elem('feMergeNode', {
    "in": 'SourceGraphic'
  });
  var blockHighlightFilter = defs.elem('filter', {
    id: "entryBlockHighlightFilter_".concat(suffix)
  });
  blockHighlightFilter.elem('feOffset', {
    result: 'offOut',
    "in": 'SourceGraphic',
    dx: 0,
    dy: 0
  });
  blockHighlightFilter.elem('feColorMatrix', {
    result: 'matrixOut',
    "in": 'offOut',
    type: 'matrix',
    values: '1.3 0 0 0 0 0 1.3 0 0 0 0 0 1.3 0 0 0 0 0 1 0'
  });
  defs.elem('filter', {
    id: "entryBlockDarkenFilter_".concat(suffix)
  }).elem('feColorMatrix', {
    type: 'matrix',
    values: '.45 0 0 0 0 0 .45 0 0 0 0 0 .45 0 0 0 0 0 1 0'
  });
  if (!isOnlyBlock) {
    var buttonShadow = defs.elem('filter', {
      id: 'entryButtonShadowFilter'
    });
    buttonShadow.elem('feOffset', {
      result: 'offOut',
      "in": 'SourceGraphic',
      dx: 1,
      dy: 1
    });
    buttonShadow.elem('feColorMatrix', {
      result: 'matrixOut',
      "in": 'offOut',
      type: 'matrix',
      values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
    });
    buttonShadow.elem('feGaussianBlur', {
      result: 'blurOut',
      "in": 'matrixOut',
      stdDeviation: '1'
    });
    buttonShadow.elem('feBlend', {
      "in": 'SourceGraphic',
      in2: 'blurOut',
      mode: 'normal'
    });
  }
};
Entry.Utils.addBlockPattern = function (boardSvgDom, suffix) {
  var pattern = boardSvgDom.elem('pattern', {
    id: "blockHoverPattern_".concat(suffix),
    "class": 'blockHoverPattern',
    patternUnits: 'userSpaceOnUse',
    patternTransform: 'translate(12, 0)',
    x: 0,
    y: 0,
    width: 48,
    height: 28,
    style: 'display: none'
  });
  var imagePath = "".concat(Entry.mediaFilePath, "block_pattern_(order).svg");
  var order = '(order)';
  for (var i = 1; i < 5; i++) {
    pattern.elem('image', {
      "class": "pattern".concat(i),
      href: imagePath.replace(order, i),
      x: 0,
      y: 0,
      width: 48,
      height: 28
    });
  }
  return {
    pattern: pattern
  };
};
function handleOptionalBlocksActive(item) {
  var _item$expansionBlocks = item.expansionBlocks,
    expansionBlocks = _item$expansionBlocks === void 0 ? [] : _item$expansionBlocks,
    _item$aiUtilizeBlocks = item.aiUtilizeBlocks,
    aiUtilizeBlocks = _item$aiUtilizeBlocks === void 0 ? [] : _item$aiUtilizeBlocks;
  if (expansionBlocks.length > 0) {
    Entry.expansion.addExpansionBlocks(expansionBlocks);
  }
  if (aiUtilizeBlocks.length > 0) {
    Entry.aiUtilize.addAIUtilizeBlocks(aiUtilizeBlocks);
  }
}
Entry.Utils.addNewBlock = function (item) {
  var script = item.script,
    functions = item.functions,
    messages = item.messages,
    variables = item.variables,
    _item$learning = item.learning,
    learning = _item$learning === void 0 ? {} : _item$learning,
    _item$tables = item.tables,
    tables = _item$tables === void 0 ? [] : _item$tables,
    _item$expansionBlocks2 = item.expansionBlocks,
    expansionBlocks = _item$expansionBlocks2 === void 0 ? [] : _item$expansionBlocks2,
    _item$aiUtilizeBlocks2 = item.aiUtilizeBlocks,
    aiUtilizeBlocks = _item$aiUtilizeBlocks2 === void 0 ? [] : _item$aiUtilizeBlocks2;
  var parseScript = JSON.parse(script);
  if (!parseScript) {
    return;
  }
  if (Entry.getMainWS().mode === Entry.Workspace.MODE_VIMBOARD && (!Entry.TextCodingUtil.canUsePythonVariables(variables) || !Entry.TextCodingUtil.canUsePythonFunctions(functions))) {
    return Entry.modal.alert(Lang.Menus.object_import_syntax_error);
  }
  var objectIdMap = {};
  variables.forEach(function (variable) {
    var object = variable.object;
    if (object) {
      variable.object = _.get(Entry, ['container', 'selectedObject', 'id'], '');
    }
  });
  _DataTable["default"].setTables(tables);
  if (!Entry.options.aiUtilizeDisable) {
    Entry.aiLearning.load(learning);
  }
  handleOptionalBlocksActive(item);
  Entry.variableContainer.appendMessages(messages);
  Entry.variableContainer.appendVariables(variables);
  Entry.variableContainer.appendFunctions(functions);
  if (!Entry.container || !Entry.container.isSceneObjectsExist()) {
    if (Entry.toast && !(this.objectAlert && Entry.toast.isOpen(this.objectAlert))) {
      this.objectAlert = Entry.toast.alert(Lang.Workspace.add_object_alert, Lang.Workspace.add_object_alert_msg);
    }
    return;
  }
  Entry["do"]('addThread', parseScript.map(function (block) {
    block.id = Entry.generateHash();
    return block;
  }));
};
Entry.Utils.addNewObject = function (sprite) {
  if (sprite) {
    var objects = sprite.objects,
      functions = sprite.functions,
      messages = sprite.messages,
      variables = sprite.variables,
      _sprite$tables = sprite.tables,
      tables = _sprite$tables === void 0 ? [] : _sprite$tables,
      _sprite$expansionBloc = sprite.expansionBlocks,
      expansionBlocks = _sprite$expansionBloc === void 0 ? [] : _sprite$expansionBloc,
      _sprite$aiUtilizeBloc = sprite.aiUtilizeBlocks,
      aiUtilizeBlocks = _sprite$aiUtilizeBloc === void 0 ? [] : _sprite$aiUtilizeBloc;
    if (Entry.getMainWS().mode === Entry.Workspace.MODE_VIMBOARD && (!Entry.TextCodingUtil.canUsePythonVariables(variables) || !Entry.TextCodingUtil.canUsePythonFunctions(functions))) {
      return Entry.modal.alert(Lang.Menus.object_import_syntax_error);
    }
    var objectIdMap = {};
    _DataTable["default"].setTables(tables);
    handleOptionalBlocksActive(sprite);
    variables.forEach(function (variable) {
      var object = variable.object;
      if (object) {
        var id = variable.id;
        var idMap = objectIdMap[object];
        variable.id = Entry.generateHash();
        if (!idMap) {
          variable.object = Entry.generateHash();
          objectIdMap[object] = {
            objectId: variable.object,
            variableOriginId: [id],
            variableId: [variable.id]
          };
        } else {
          variable.object = idMap.objectId;
          idMap.variableOriginId.push(id);
          idMap.variableId.push(variable.id);
        }
      }
    });
    Entry.variableContainer.appendMessages(messages);
    Entry.variableContainer.appendVariables(variables);
    Entry.variableContainer.appendFunctions(functions);
    objects.forEach(function (object) {
      var idMap = objectIdMap[object.id];
      if (idMap) {
        var script = object.script;
        idMap.variableOriginId.forEach(function (id, idx) {
          var regex = new RegExp(id, 'gi');
          script = script.replace(regex, idMap.variableId[idx]);
        });
        object.script = script;
        object.id = idMap.objectId;
      } else if (Entry.container.getObject(object.id)) {
        object.id = Entry.generateHash();
      }
      if (!object.objectType) {
        object.objectType = 'sprite';
      }
      Entry.container.addObject(object, 0);
    });
  }
};
Entry.Utils.COLLISION = {
  NONE: 0,
  UP: 1,
  RIGHT: 2,
  LEFT: 3,
  DOWN: 4
};
Entry.Utils.createMouseEvent = function (type, event) {
  var e = document.createEvent('MouseEvent');
  e.initMouseEvent(type, true, true, window, 0, 0, 0, event.clientX, event.clientY, false, false, false, false, 0, null);
  return e;
};
Entry.Utils.stopProjectWithToast = (0, _throttle2["default"])(/*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(scope, message, error) {
    var block, toast, engine, id, view, newError;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          block = scope.block;
          message = message || 'Runtime Error';
          toast = error.toast;
          engine = Entry.engine;
          if (!(engine && engine.isState('run'))) {
            _context.next = 1;
            break;
          }
          _context.next = 1;
          return engine.toggleStop();
        case 1:
          if (Entry.type === 'workspace') {
            if (scope.block && 'funcBlock' in scope.block) {
              block = scope.block.funcBlock;
            } else if (scope.funcExecutor) {
              block = scope.funcExecutor.scope.block;
              Entry.Func.edit(scope.type);
            }
            if (block) {
              id = block.getCode().object && block.getCode().object.id;
              if (id) {
                Entry.container.selectObject(block.getCode().object.id, true);
              }
              view = block.view;
              view && view.getBoard().activateBlock(block);
            }
          }
          if (message === 'IncompatibleError' && Entry.toast) {
            Entry.toast.alert(Lang.Msgs.warn, toast || [Lang.Workspace.check_runtime_error, Lang.Workspace.check_browser_error], true);
            Entry.engine.hideAllAudioPanel();
          }
          if (message === 'OfflineError' && Entry.toast) {
            Entry.toast.alert(Lang.Msgs.warn, toast || [Lang.Workspace.check_runtime_error, Lang.Workspace.offline_not_compatible_error], true);
          } else if (Entry.toast) {
            Entry.toast.alert(Lang.Msgs.warn, Lang.Workspace.check_runtime_error, true);
          }
          if (!error) {
            _context.next = 2;
            break;
          }
          newError = new Error("".concat(message, ": ").concat(error.message));
          newError.stack = error.stack;
          throw newError;
        case 2:
          throw new Error(message);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}(), 300, {
  trailing: false
});
Entry.Utils.AsyncError = function (message) {
  this.name = 'AsyncError';
  this.message = message || 'Waiting for callback';
};
Entry.Utils.AsyncError.prototype = new Error();
Entry.Utils.AsyncError.prototype.constructor = Entry.Utils.AsyncError;
Entry.Utils.IncompatibleError = function (message, toast) {
  this.name = 'IncompatibleError';
  this.message = message || 'IncompatibleError';
  this.toast = toast || null;
};
Entry.Utils.IncompatibleError.prototype = new Error();
Entry.Utils.IncompatibleError.prototype.constructor = Entry.Utils.IncompatibleError;
Entry.Utils.OfflineError = function (message, toast) {
  this.name = 'OfflineError';
  this.message = message || 'OfflineError';
  this.toast = toast || null;
};
Entry.Utils.OfflineError.prototype = new Error();
Entry.Utils.OfflineError.prototype.constructor = Entry.Utils.OfflineError;
Entry.Utils.isChrome = function () {
  return /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
};
Entry.Utils.getUsedFonts = function (project) {
  if (!project) {
    return;
  }
  var getFamily = function getFamily(x) {
    return x.entity.font.split(' ').filter(function (t) {
      return t.indexOf('bold') < 0 && t.indexOf('italic') < 0 && t.indexOf('px') < 0;
    }).join(' ');
  };
  return (0, _uniq2["default"])(project.objects.filter(function (x) {
    return x.objectType === 'textBox';
  }).map(getFamily));
};
Entry.Utils.waitForWebfonts = function (fonts, callback) {
  return Promise.all(fonts.map(function (font) {
    return new Promise(function (resolve) {
      (0, _fontfaceonload["default"])(font, {
        success: function success() {
          resolve();
        },
        error: function error() {
          console.log('fail', font);
          resolve();
        },
        timeout: 5000
      });
    });
  })).then(function () {
    console.log('font loaded');
    callback && callback();
  });
};
window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();
Entry.isMobile = function () {
  if (Entry.device) {
    return Entry.device === 'tablet';
  }
  var platform = window.platform;
  var ret = platform && platform.type && (platform.type === 'tablet' || platform.type === 'mobile');
  if (ret) {
    Entry.device = 'tablet';
    return true;
  } else {
    Entry.device = 'desktop';
    return false;
  }
};
Entry.Utils.mobileAgentParser = function (userAgent) {
  var applePhone = /iPhone/i;
  var appleIpod = /iPod/i;
  var appleTablet = /iPad/i;
  var androidPhone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i; // Match 'Android' AND 'Mobile'
  var androidTablet = /Android/i;
  var amazonPhone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i;
  var amazonTablet =
  // eslint-disable-next-line max-len
  /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i;
  var windowsPhone = /Windows Phone/i;
  var windowsTablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i; // Match 'Windows' AND 'ARM'
  var otherBlackberry = /BlackBerry/i;
  var otherBlackberry10 = /BB10/i;
  var otherOpera = /Opera Mini/i;
  var otherChrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i;
  var otherFirefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i; // Match 'Firefox' AND 'Mobile'
  var sevenInch = new RegExp('(?:' +
  // Non-capturing group
  'Nexus 7' +
  // Nexus 7
  '|' +
  // OR
  'BNTV250' +
  // B&N Nook Tablet 7 inch
  '|' +
  // OR
  'Kindle Fire' +
  // Kindle Fire
  '|' +
  // OR
  'Silk' +
  // Kindle Fire, Silk Accelerated
  '|' +
  // OR
  'GT-P1000' +
  // Galaxy Tab 7 inch
  ')',
  // End non-capturing group

  'i'); // Case-insensitive matching

  var match = function match(regex, userAgent) {
    return regex.test(userAgent);
  };
  var ua = userAgent || navigator.userAgent;

  // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.
  var tmp = ua.split('[FBAN');
  if (typeof tmp[1] !== 'undefined') {
    ua = tmp[0];
  }

  // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probable happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.
  tmp = ua.split('Twitter');
  if (typeof tmp[1] !== 'undefined') {
    ua = tmp[0];
  }
  this.apple = {
    phone: match(applePhone, ua),
    ipod: match(appleIpod, ua),
    tablet: !match(applePhone, ua) && match(appleTablet, ua),
    device: match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)
  };
  this.amazon = {
    phone: match(amazonPhone, ua),
    tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
    device: match(amazonPhone, ua) || match(amazonTablet, ua)
  };
  this.android = {
    phone: match(amazonPhone, ua) || match(androidPhone, ua),
    tablet: !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
    device: match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)
  };
  this.windows = {
    phone: match(windowsPhone, ua),
    tablet: match(windowsTablet, ua),
    device: match(windowsPhone, ua) || match(windowsTablet, ua)
  };
  this.other = {
    blackberry: match(otherBlackberry, ua),
    blackberry10: match(otherBlackberry10, ua),
    opera: match(otherOpera, ua),
    firefox: match(otherFirefox, ua),
    chrome: match(otherChrome, ua),
    device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
  };
  this.seven_inch = match(sevenInch, ua);
  this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

  // excludes 'other' devices and ipods, targeting touchscreen phones
  this.phone = this.apple.phone || this.android.phone || this.windows.phone;

  // excludes 7 inch devices, classifying as phone or tablet is left to the user
  this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
  return this;
};
Entry.Utils.convertMouseEvent = function (e) {
  if (e.originalEvent && e.originalEvent.touches) {
    return e.originalEvent.touches[0];
  } else if (e.changedTouches) {
    return e.changedTouches[0];
  } else {
    return e;
  }
};
Entry.Utils.hasSpecialCharacter = function (str) {
  var reg = /!|@|#|\$|%|\^|&|\*|\(|\)|\+|=|-|\[|\]|\\|\'|;|,|\.|\/|{|}|\||\"|:|<|>|\?/g;
  return reg.test(str);
};
Entry.Utils.getBlockCategory = function () {
  var map = {};
  var allBlocks;
  return function (blockType) {
    if (!blockType) {
      return;
    }
    if (map[blockType]) {
      return map[blockType];
    }
    if (!allBlocks) {
      allBlocks = EntryStatic.getAllBlocks();
    }
    for (var i = 0; i < allBlocks.length; i++) {
      var data = allBlocks[i];
      var category = data.category;
      if (data.blocks.indexOf(blockType) > -1) {
        map[blockType] = category;
        return category;
      }
    }
  };
}();
Entry.Utils.getUniqObjectsBlocks = function (objects) {
  var _typePicker = _.partial(_.result, _, 'type');
  return _.chain(objects || Entry.container.objects_).map(function (_ref5) {
    var script = _ref5.script;
    if (!(script instanceof Entry.Code)) {
      script = new Entry.Code(script);
    }
    return script.getBlockList().map(_typePicker);
  }).flatten().uniq().value();
};
Entry.Utils.getObjectsBlocks = function (objects) {
  var _typePicker = _.partial(_.result, _, 'type');
  return _.chain(objects || Entry.container.objects_).map(function (_ref6) {
    var script = _ref6.script;
    if (!(script instanceof Entry.Code)) {
      script = new Entry.Code(script);
    }
    return script.getBlockList(true).map(_typePicker);
  }).flatten().value();
};
var scheduler = new _scheduler.Scheduler();
Entry.Utils.getObjectsBlocksBySceneId = _.memoize(function (sceneId) {
  if (!sceneId) {
    return [];
  }
  var _typePicker = _.partial(_.result, _, 'type');
  var job = new Promise(function (resolve) {
    scheduler.run(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var result, codes, _iterator, _step, _code$scene, code, script, _t;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            result = [];
            codes = Entry.container.objects_;
            _iterator = _createForOfIteratorHelper(codes);
            _context2.prev = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context2.next = 5;
              break;
            }
            code = _step.value;
            if (!((code === null || code === void 0 || (_code$scene = code.scene) === null || _code$scene === void 0 ? void 0 : _code$scene.id) !== sceneId)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("continue", 4);
          case 3:
            script = code.script;
            if (!(script instanceof Entry.Code)) {
              script = new Entry.Code(script);
            }
            result.push(script.getBlockListForEventThread(true).map(_typePicker));
            _context2.next = 4;
            return;
          case 4:
            _context2.next = 2;
            break;
          case 5:
            _context2.next = 7;
            break;
          case 6:
            _context2.prev = 6;
            _t = _context2["catch"](1);
            _iterator.e(_t);
          case 7:
            _context2.prev = 7;
            _iterator.f();
            return _context2.finish(7);
          case 8:
            resolve(_.flatten(result));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 6, 7, 8]]);
    }));
  });
  return job;
});
Entry.Utils.getObjectsBlocksForEventThread = _.memoize(function (object) {
  var nowScheduler = new _scheduler.Scheduler();
  var _typePicker = _.partial(_.result, _, 'type');
  var job = new Promise(function (resolve) {
    nowScheduler.run(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var result, codes, _iterator2, _step2, code, script, _t2, _t3;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            result = [];
            _context3.prev = 1;
            if (object) {
              codes = [object];
            } else {
              codes = Entry.container.objects_;
            }
            _iterator2 = _createForOfIteratorHelper(codes);
            _context3.prev = 2;
            _iterator2.s();
          case 3:
            if ((_step2 = _iterator2.n()).done) {
              _context3.next = 5;
              break;
            }
            code = _step2.value;
            script = code.script;
            if (!(script instanceof Entry.Code)) {
              script = new Entry.Code(script);
            }
            result.push(script.getBlockListForEventThread(true).map(_typePicker));
            _context3.next = 4;
            return;
          case 4:
            _context3.next = 3;
            break;
          case 5:
            _context3.next = 7;
            break;
          case 6:
            _context3.prev = 6;
            _t2 = _context3["catch"](2);
            _iterator2.e(_t2);
          case 7:
            _context3.prev = 7;
            _iterator2.f();
            return _context3.finish(7);
          case 8:
            resolve(_.flatten(result));
            _context3.next = 10;
            break;
          case 9:
            _context3.prev = 9;
            _t3 = _context3["catch"](1);
            console.warn('blockCount : ', _t3);
            resolve(_.flatten(result));
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 9], [2, 6, 7, 8]]);
    }));
  });
  return job;
});
Entry.Utils.clearObjectsBlocksForEventThread = function () {
  Entry.Utils.getObjectsBlocksForEventThread.cache = new _.memoize.Cache();
  Entry.Utils.getObjectsBlocksBySceneId.cache = new _.memoize.Cache();
};
Entry.Utils.makeCategoryDataByBlocks = function (blockArr) {
  if (!blockArr) {
    return;
  }
  var that = this;
  var data = EntryStatic.getAllBlocks();
  var categoryIndexMap = {};
  for (var i = 0; i < data.length; i++) {
    var datum = data[i];
    datum.blocks = [];
    categoryIndexMap[datum.category] = i;
  }
  blockArr.forEach(function (b) {
    var category = that.getBlockCategory(b);
    var index = categoryIndexMap[category];
    if (index === undefined) {
      return;
    }
    data[index].blocks.push(b);
  });
  var allBlocks = EntryStatic.getAllBlocks();
  return allBlocks.map(function (block) {
    var category = block.category,
      blocks = block.blocks;
    if (category === 'func') {
      return {
        blocks: []
      };
    }
    return {
      category: category,
      blocks: (0, _intersection2["default"])(blockArr, blocks)
    };
  }).filter(function (_ref7) {
    var blocks = _ref7.blocks;
    return blocks.length;
  });
};
Entry.Utils.blur = function () {
  var elem = document.activeElement;
  elem && elem.blur && elem.blur();
};
Entry.Utils.getWindow = function (hashId) {
  if (!hashId) {
    return;
  }
  for (var i = 0; i < window.frames.length; i++) {
    var frame = window.frames[i];
    if (frame.Entry && frame.Entry.hashId === hashId) {
      return frame;
    }
  }
};
Entry.Utils.restrictAction = function () {
  var exceptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  var noDispose = arguments.length > 2 ? arguments[2] : undefined;
  var that = this;
  exceptions = exceptions.map(_.head);
  var handler = function handler(e) {
    e = e || window.event;
    var target = e.target || e.srcElement;
    if (!that.isRightButton(e)) {
      for (var i = 0; i < exceptions.length; i++) {
        var exception = exceptions[i];
        if (exception === target || $.contains(exception, target)) {
          if (!noDispose) {
            callback(e);
          } else {
            target.focus && target.focus();
          }
          return;
        }
      }
    }
    if (!e.preventDefault) {
      //IE quirks
      e.returnValue = false;
      e.cancelBubble = true;
    }
    e.preventDefault();
    e.stopPropagation();
  };
  this._restrictHandler = handler;
  var entryDom = Entry.getDom();
  Entry.Utils.disableContextmenu(entryDom);
  if (entryDom.addEventListener) {
    entryDom.addEventListener('click', handler, true);
    entryDom.addEventListener('mousedown', handler, true);
    entryDom.addEventListener('mouseup', handler, true);
    entryDom.addEventListener('touchstart', handler, true);
  } else {
    entryDom.attachEvent('onclick', handler);
    entryDom.attachEvent('onmousedown', handler);
    entryDom.attachEvent('onmouseup', handler);
    entryDom.attachEvent('ontouchstart', handler);
  }
};
Entry.Utils.allowAction = function () {
  var entryDom = Entry.getDom();
  Entry.Utils.enableContextmenu(entryDom);
  if (this._restrictHandler) {
    if (entryDom.addEventListener) {
      entryDom.removeEventListener('click', this._restrictHandler, true);
      entryDom.removeEventListener('mousedown', this._restrictHandler, true);
      entryDom.removeEventListener('mouseup', this._restrictHandler, true);
      entryDom.removeEventListener('touchstart', this._restrictHandler, true);
    } else {
      entryDom.detachEvent('onclick', this._restrictHandler);
      entryDom.detachEvent('onmousedown', this._restrictHandler);
      entryDom.detachEvent('onmouseup', this._restrictHandler);
      entryDom.detachEvent('ontouchstart', this._restrictHandler);
    }
    delete this._restrictHandler;
  }
};
Entry.Utils.glideBlock = function (svgGroup, x, y, callback) {
  var rect = svgGroup.getBoundingClientRect();
  var svgDom = Entry.Dom($('<svg id="globalSvg" width="10" height="10"' + 'version="1.1" xmlns="http://www.w3.org/2000/svg"></svg>'), {
    parent: $(document.body)
  });
  svgGroup = $(svgGroup.cloneNode(true));
  svgGroup.attr({
    transform: 'translate(8,0)'
  });
  svgDom.append(svgGroup);
  svgDom.css({
    top: rect.top,
    left: rect.left
  });
  svgDom.velocity({
    top: y,
    left: x - 8
  }, {
    duration: 1200,
    complete: function complete() {
      setTimeout(function () {
        svgDom.remove();
        callback();
      }, 500);
    },
    easing: 'ease-in-out'
  });
};
Entry.Utils.getScrollPos = function () {
  return {
    left: window.pageXOffset || document.documentElement.scrollLeft,
    top: window.pageYOffset || document.documentElement.scrollTop
  };
};
Entry.Utils.isPointInRect = function (_ref8, _ref9) {
  var x = _ref8.x,
    y = _ref8.y;
  var top = _ref9.top,
    bottom = _ref9.bottom,
    left = _ref9.left,
    right = _ref9.right;
  return _.inRange(x, left, right) && _.inRange(y, top, bottom);
};
Entry.Utils.getBoundingClientRectMemo = _.memoize(function (target) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var rect = target.getBoundingClientRect();
  var result = {
    top: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    right: rect.right
  };
  Object.keys(offset).forEach(function (key) {
    result[key] += offset[key];
  });
  return result;
});
Entry.Utils.clearClientRectMemo = function () {
  Entry.Utils.getBoundingClientRectMemo.cache = new _.memoize.Cache();
};
Entry.Utils.getPosition = function (event) {
  var position = {
    x: 0,
    y: 0
  };
  if (event.touches && event.touches[0]) {
    var touch = event.touches[0];
    position.x = touch.pageX;
    position.y = touch.pageY;
  } else {
    position.x = event.pageX;
    position.y = event.pageY;
  }
  return position;
};
Entry.Utils.copy = function (target) {
  return JSON.parse(JSON.stringify(target));
};

//helper function for development and debug
Entry.Utils.getAllObjectsBlockList = function () {
  return Entry.container.objects_.reduce(function (prev, _ref0) {
    var script = _ref0.script;
    return prev.concat(script.getBlockList());
  }, []);
};
Entry.Utils.toFixed = function (value, len) {
  var length = len || 1;
  var powValue = Math.pow(10, length);
  var retValue = Math.round(value * powValue) / powValue;
  if (Entry.isFloat(retValue)) {
    return String(retValue);
  } else {
    retValue += '.';
    for (var i = 0; i < length; i++) {
      retValue += '0';
    }
    return retValue;
  }
};
Entry.Utils.setVolume = function (volume) {
  var _this = this;
  this._volume = (0, _clamp2["default"])(volume, 0, 1);
  Entry.soundInstances.getAllValues().filter(function (_ref1) {
    var soundType = _ref1.soundType;
    return !soundType;
  }).forEach(function (instance) {
    instance.volume = _this._volume;
  });
};
Entry.Utils.getVolume = function () {
  if (this._volume || this._volume === 0) {
    return this._volume;
  }
  return 1;
};
Entry.Utils.playBGM = function (id) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var instance = createjs.Sound.play(id, (0, _extends2["default"])({
    volume: 1
  }, option));
  return instance;
};
Entry.Utils.addBGMInstances = function (instance) {
  var sprite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'global';
  Entry.bgmInstances.add(sprite, instance);
  instance.on('complete', function () {
    Entry.bgmInstances.deleteItemByKeyAndValue(sprite, instance);
  });
};
Entry.Utils.forceStopBGM = function () {
  _.each((0, _toConsumableArray2["default"])(Entry.bgmInstances.getAllValues()), function (instance) {
    var _instance$dispatchEve, _instance$stop;
    instance === null || instance === void 0 || (_instance$dispatchEve = instance.dispatchEvent) === null || _instance$dispatchEve === void 0 || _instance$dispatchEve.call(instance, 'complete');
    instance === null || instance === void 0 || (_instance$stop = instance.stop) === null || _instance$stop === void 0 || _instance$stop.call(instance);
  });
  Entry.bgmInstances.clear();
};
Entry.Utils.forceStopSounds = function () {
  _.each((0, _toConsumableArray2["default"])(Entry.soundInstances.getAllValues()), function (instance) {
    var _instance$dispatchEve2, _instance$stop2;
    instance === null || instance === void 0 || (_instance$dispatchEve2 = instance.dispatchEvent) === null || _instance$dispatchEve2 === void 0 || _instance$dispatchEve2.call(instance, 'complete');
    instance === null || instance === void 0 || (_instance$stop2 = instance.stop) === null || _instance$stop2 === void 0 || _instance$stop2.call(instance);
  });
  Entry.soundInstances.clear();
};
Entry.Utils.playSound = function (id) {
  var _instance$sourceNode;
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var instance = createjs.Sound.play(id, (0, _extends2["default"])({
    volume: this._volume
  }, option));
  if ((_instance$sourceNode = instance.sourceNode) !== null && _instance$sourceNode !== void 0 && _instance$sourceNode.playbackRate) {
    instance.sourceNode.playbackRate.value = Entry.playbackRateValue;
  }
  return instance;
};
Entry.Utils.addSoundInstances = function (instance) {
  var sprite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'global';
  Entry.soundInstances.add(sprite, instance);
  instance.on('complete', function () {
    Entry.soundInstances.deleteItemByKeyAndValue(sprite, instance);
  });
};
Entry.Utils.pauseSoundInstances = function () {
  Entry.soundInstances.getAllValues().forEach(function (instance) {
    instance.paused = true;
  });
  Entry.bgmInstances.getAllValues().forEach(function (instance) {
    instance.paused = true;
  });
};
Entry.Utils.recoverSoundInstances = function () {
  Entry.soundInstances.getAllValues().forEach(function (instance) {
    var _instance$sourceNode2;
    instance.paused = false;
    if ((_instance$sourceNode2 = instance.sourceNode) !== null && _instance$sourceNode2 !== void 0 && _instance$sourceNode2.playbackRate) {
      instance.sourceNode.playbackRate.value = Entry.playbackRateValue;
    }
  });
  Entry.bgmInstances.getAllValues().forEach(function (instance) {
    instance.paused = false;
  });
};
Entry.Utils.hasClass = function (elem, name) {
  return " ".concat(elem.getAttribute('class'), " ").indexOf(" ".concat(name, " ")) >= 0;
};
Entry.Utils.addClass = function (elem, name) {
  if (!Entry.Utils.hasClass(elem, name)) {
    elem.setAttribute('class', (elem.getAttribute('class') ? "".concat(elem.className, " ") : '') + name);
  }
};
Entry.Utils.toggleClass = function (elem, name, force) {
  if (force || typeof force === 'undefined' && !Entry.Utils.hasClass(elem, name)) {
    Entry.Utils.addClass(elem, name);
  } else {
    Entry.Utils.removeClass(elem, name);
  }
};
Entry.Utils.removeClass = function (elem, name) {
  var set = " ".concat(elem.getAttribute('class'), " ");
  while (set.indexOf(" ".concat(name, " ")) >= 0) {
    set = set.replace(" ".concat(name, " "), ' ');
  }
  var result = typeof set.trim === 'function' ? set.trim() : set.replace(/^\s+|\s+$/g, '');
  elem.setAttribute('class', result);
};
Entry.Utils.bindBlockViewHoverEvent = function (board, dom) {
  if (Entry.isMobile()) {
    return;
  }
  dom.on('mouseenter mouseleave', 'path', function (_ref10) {
    var type = _ref10.type;
    if (this.getAttribute('class') !== 'blockPath') {
      return;
    }
    var block = board.code.findById(this.getAttribute('blockId'));
    if (!block) {
      return;
    }
    var blockView = block.view;
    if (!blockView._mouseEnable) {
      return;
    }
    blockView.setHoverBlockView({
      that: blockView,
      blockView: type === 'mouseenter' ? blockView : undefined
    });
  });
};
Entry.Utils.bindBlockExecuteFocusEvents = function () {
  var _this2 = this;
  Entry.addEventListener('blockExecute', function (view) {
    if (!view) {
      return;
    }
    _this2.focusBlockView(view.getBoard(), view);
  });
  Entry.addEventListener('blockExecuteEnd', this.focusBlockView);
};
Entry.Utils.focusBlockView = function () {
  var _last;
  function _getAllElem(elem) {
    return $(elem).find('*:not(g)');
  }
  return function (board, blockView) {
    var _ref11 = board || Entry.getMainWS().board || {},
      svgGroup = _ref11.svgGroup,
      suffix = _ref11.suffix;
    if (!svgGroup || !suffix || _last && _last === blockView) {
      return;
    }
    if (blockView) {
      //darken all
      _getAllElem(svgGroup).attr('filter', "url(#entryBlockDarkenFilter_".concat(suffix, ")"));

      //brighten only block
      var _path = blockView._path,
        contentSvgGroup = blockView.contentSvgGroup;
      $(_path).removeAttr('filter');
      $(contentSvgGroup).find('*:not(g)').removeAttr('filter');
    } else {
      //brighten all
      _getAllElem(svgGroup).removeAttr('filter');
    }
    _last = blockView;
  };
}();
Entry.Utils.isDomActive = function (dom) {
  return !!(dom && document.activeElement === dom);
};
Entry.Utils.when = function (predicate, fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (predicate.apply(this, args)) {
      return fn && fn.apply(this, args);
    }
  };
};
Entry.Utils.whenEnter = function (fn) {
  return Entry.Utils.when(function (_ref12) {
    var keyCode = _ref12.keyCode,
      repeat = _ref12.repeat;
    return keyCode === 13 && !repeat;
  }, fn);
};
Entry.Utils.blurWhenEnter = Entry.Utils.whenEnter(function () {
  this.blur();
});
Entry.Utils.whenWithTimeout = function (predicate, fn) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  return function () {
    var _this3 = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (this._timer) {
      clearTimeout(this._timer);
      delete this._timer;
    }
    this._timer = setTimeout(function () {
      if (predicate.apply(_this3, args)) {
        return fn.apply(_this3, args);
      }
    }, time);
  };
};
Entry.Utils.setBlurredTimer = function (func) {
  return Entry.Utils.whenWithTimeout(function () {
    if (this._focused) {
      this._focused = false;
      return true;
    }
    return false;
  }, func);
};
Entry.Utils.setFocused = function () {
  if (this._timer) {
    clearTimeout(this._timer);
    delete this._timer;
  }
  this._focused = true;
};
Entry.Utils.focusIfNotActive = function (dom) {
  if (Array.isArray(dom)) {
    dom = Entry.getDom(dom);
  }
  if (!dom) {
    return;
  }
  if (!Entry.Utils.isDomActive(dom)) {
    dom.focus && dom.focus();
  }
};

// 터치와 마우스의 이벤트를 맞춰주는 함수
Entry.Utils.getMouseEvent = function (event) {
  var mouseEvent;
  if (event.originalEvent && event.originalEvent.touches) {
    mouseEvent = event.originalEvent.touches[0];
  } else if (event.touches) {
    mouseEvent = event.touches[0];
  } else {
    mouseEvent = event;
  }
  return mouseEvent;
};
Entry.Utils.removeBlockByType = function (blockType, callback) {
  var objects = Entry.container.getAllObjects();
  objects.forEach(function (_ref13) {
    var id = _ref13.id,
      script = _ref13.script;
    Entry["do"]('selectObject', id).isPass(true);
    script.getBlockList(false, blockType).forEach(function (b, index) {
      Entry["do"]('destroyBlock', b).isPass(true);
    });
  });
  Entry.variableContainer.removeBlocksInFunctionByType(blockType);
  if (callback) {
    callback();
  }
};
Entry.Utils.removeBlockByType2 = function (blockType, callback) {
  Entry.variableContainer.removeBlocksInFunctionByType(blockType);
  var objects = Entry.container.getAllObjects();
  objects.forEach(function (_ref14) {
    var id = _ref14.id,
      script = _ref14.script;
    script.getBlockList(false, blockType).forEach(function (block, index) {
      block.destroy();
    });
  });
  if (callback) {
    callback();
  }
};
Entry.Utils.sleep = function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
};
Entry.Utils.runAsync = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(func) {
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return Entry.Utils.sleep();
        case 1:
          _context4.next = 2;
          return func();
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function (_x4) {
    return _ref15.apply(this, arguments);
  };
}();
Entry.Utils.runAsyncCurry = function (func) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var _args5 = arguments;
    return _regenerator["default"].wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 1;
          return Entry.Utils.sleep(time);
        case 1:
          _context5.next = 2;
          return func.apply(void 0, _args5);
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
Entry.Utils.removeBlockByTypeAsync = /*#__PURE__*/function () {
  var _ref17 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(blockType, callback) {
    var objects;
    return _regenerator["default"].wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          Entry.dispatchEvent('removeFunctionsStart');
          _context8.next = 1;
          return Entry.variableContainer.removeBlocksInFunctionByTypeAsync(blockType);
        case 1:
          objects = Entry.container.getAllObjects();
          _context8.next = 2;
          return Promise.all(objects.map(/*#__PURE__*/function () {
            var _ref19 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref18) {
              var script;
              return _regenerator["default"].wrap(function (_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    script = _ref18.script;
                    _context7.next = 1;
                    return Promise.all(script.getBlockList(false, blockType).map(Entry.Utils.runAsyncCurry(/*#__PURE__*/function () {
                      var _ref20 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(block) {
                        return _regenerator["default"].wrap(function (_context6) {
                          while (1) switch (_context6.prev = _context6.next) {
                            case 0:
                              block.destroy();
                            case 1:
                            case "end":
                              return _context6.stop();
                          }
                        }, _callee6);
                      }));
                      return function (_x8) {
                        return _ref20.apply(this, arguments);
                      };
                    }())));
                  case 1:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            return function (_x7) {
              return _ref19.apply(this, arguments);
            };
          }()));
        case 2:
          Entry.dispatchEvent('removeFunctionsEnd');
          if (callback) {
            callback();
          }
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function (_x5, _x6) {
    return _ref17.apply(this, arguments);
  };
}();
Entry.Utils.isUsedBlockType = function (blockType) {
  var objects = Entry.container.getAllObjects();
  var usedInObject = objects.some(function (_ref21) {
    var script = _ref21.script;
    return !!script.getBlockList(false, blockType).length;
  });
  if (usedInObject) {
    return true;
  }
  return Entry.variableContainer.isUsedBlockTypeInFunction(blockType);
};
Entry.Utils.combineCloudVariable = function (_ref22) {
  var variables = _ref22.variables,
    cloudVariable = _ref22.cloudVariable;
  var items;
  if (typeof cloudVariable === 'string') {
    try {
      items = JSON.parse(cloudVariable);
    } catch (e) {}
  }
  if (!Array.isArray(items)) {
    return variables;
  }
  return variables.map(function (variable) {
    var cloud = items.find(function (_ref23) {
      var id = _ref23.id;
      return id === variable.id;
    });
    if (cloud) {
      return _objectSpread(_objectSpread({}, variable), cloud);
    }
    return variable;
  });
};
Entry.Utils.asyncAnimationFrame = function (func) {
  var captureTimeout = false;
  var _asyncFunc = function asyncFunc() {
    if (!Entry.engine.isState('run')) {
      return;
    }
    if (func instanceof Promise) {
      func().then(function () {
        captureTimeout = requestAnimationFrame(_asyncFunc);
      });
    } else if (func instanceof Function) {
      func();
      captureTimeout = requestAnimationFrame(_asyncFunc);
    }
  };
  captureTimeout = requestAnimationFrame(_asyncFunc);
  return function () {
    cancelAnimationFrame(captureTimeout);
  };
};
Entry.Utils.stringFormat = function (text) {
  if (!text) {
    return text;
  }
  var result = text;
  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    var regexp = new RegExp("\\{".concat(i, "\\}"), 'gi');
    result = result.replace(regexp, i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]);
  }
  return result;
};
Entry.Utils.shortenNumber = function () {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (num >= 1000000000) {
    return "".concat((0, _round2["default"])(num / 1000000000, 1), "B");
  }
  if (num >= 1000000) {
    return "".concat((0, _round2["default"])(num / 1000000, 1), "M");
  }
  if (num >= 100000) {
    return "".concat((0, _round2["default"])(num / 1000, 1), "K");
  }
  return num;
};
Entry.Utils.doCodeChange = function () {
  if (Entry.codeChangedEvent) {
    Entry.Utils.clearObjectsBlocksForEventThread();
    Entry.codeChangedEvent.notify();
  }
};
Entry.Utils.extractTextFromHTML = function (htmlString) {
  var parser = new DOMParser();
  var dom = parser.parseFromString(htmlString, 'text/html');
  return dom.body.textContent || '';
};
Entry.Utils.getEntryjsPath = function () {
  return window.navigator.userAgent.indexOf('Electron') > -1 ? "file://".concat(window.getEntryjsPath()) : "".concat(window.location.origin, "/lib/entry-js");
};
Entry.Utils.getDeviceType = function (target) {
  var parser = new _uaParserJs.UAParser();
  var result = parser.getResult();
  return result.device.type;
};
Entry.Utils.cellToRowCol = function (cell) {
  var col = 0;
  var i = 0;
  while (i < cell.length && isNaN(cell[i])) {
    col = col * 26 + (cell.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
    i++;
  }
  var row = parseInt(cell.slice(i), 10) - 1;
  return {
    col: col,
    row: row
  };
};